
const Recipes = [
    {
        title: 'Бургер с семгой',
        id: 1,
        portion: '4',
        time: '35',
        image: '/static/images/recieps/rec1.jpg',
        type: 'no-meat'
    },
    {
        title: 'Сэндвичи с тунцом и сыром',
        id: 2,
        portion: '4',
        time: '35',
        image: '/static/images/recieps/rec2.jpg',
        type: 'no-meat'
    },
    {
        title: 'Персики на гриле с горгонзолой и медом',
        id: 3,
        portion: '4',
        time: '35',
        image: '/static/images/recieps/rec3.jpg',
        type: 'no-meat'
    },
    {
        title: 'Овощи гриль с соусом из печеного чеснока',
        id: 4,
        portion: '2',
        time: '25',
        image: '/static/images/recieps/rec-new-gril-chesnok.jpg',
        type: 'no-meat'
    },
    {
        title: 'Дорада на гриле с мандаринами и майораном',
        id: 5,
        portion: '4',
        time: '35',
        image: '/static/images/recieps/rec5.jpg',
        type: 'no-meat'
    },
    {
        title: 'Зажаренная на гриле капуста',
        id: 6,
        portion: '4',
        time: '35',
        image: '/static/images/recieps/rec6.jpg',
        type: 'no-meat'
    },
    {
        title: 'Ананас на гриле с кардамоном и ванильным мороженым',
        id: 7,
        portion: '6',
        time: '15',
        image: '/static/images/recieps/rec7.jpg',
        type: 'no-meat'
    },
    {
        title: 'Порей с чесночным майонезом',
        id: 8,
        portion: '6',
        time: '20',
        image: '/static/images/recieps/rec8.jpg',
        type: 'no-meat'
    },
    {
        title: 'Овощи с грибами на гриле по‑итальянски',
        id: 9,
        portion: '4',
        time: '30',
        image: '/static/images/recieps/rec-new-gril-ital.jpg',
        type: 'no-meat'
    },
    {
        title: 'Бургеры из киноа',
        id: 10,
        portion: '12',
        time: '35',
        image: '/static/images/recieps/rec10.jpg',
        type: 'no-meat'
    },
    {
        title: 'Стейки с картофелем и спаржей на гриле',
        id: 11,
        portion: '4',
        time: '25',
        image: '/static/images/recieps/rec11.jpg',
        type: 'meat'
    },
    {
        title: 'Тальята',
        id: 12,
        portion: '6',
        time: '15',
        image: '/static/images/recieps/rec12.jpg',
        type: 'meat'
    },
    {
        title: 'Сэндвич с яичницей, беконом и сыром',
        id: 13,
        portion: '1',
        time: '5',
        image: '/static/images/recieps/rec13.jpg',
        type: 'meat'
    },
    {
        title: 'Шаверма в пите',
        id: 14,
        portion: '4',
        time: '60',
        image: '/static/images/recieps/rec14.jpg',
        type: 'meat'
    },
    {
        title: 'Ягненок на гриле с соусом персийяд',
        id: 15,
        portion: '2',
        time: '10',
        image: '/static/images/recieps/rec15.jpg',
        type: 'meat'
    },
    {
        title: 'Цыпленок гриль с орегано',
        id: 16,
        portion: '8',
        time: '120',
        image: '/static/images/recieps/rec16.jpg',
        type: 'meat'
    },
    {
        title: 'Шашлычки из курицы, креветок и овощей',
        id: 17,
        portion: '4',
        time: '35',
        image: '/static/images/recieps/rec17.jpg',
        type: 'meat'
    },
    {
        title: 'Ягненок тандури',
        id: 18,
        portion: '6',
        time: '70',
        image: '/static/images/recieps/rec18.jpg',
        type: 'meat'
    },
    {
        title: 'Говяжьи шашлычки',
        id: 19,
        portion: '4',
        time: '20',
        image: '/static/images/recieps/rec19.jpg',
        type: 'meat'
    },
    {
        title: 'Шашлык из страуса',
        id: 20,
        portion: '4',
        time: '30',
        image: '/static/images/recieps/rec20.jpg',
        type: 'meat'
    },

]

export default Recipes



// WEBPACK FOOTER //
// ./src/store/storage.js